export const CDN_PREFIX_URI = '/t1.kakaocdn.net/kakaomobility/bike_operating_web'
